import React from "react";
import { css, jsx } from "@emotion/react";
import getBadge from "./Badges";

const WrapCardCommon = ({ post, id, isSearchCard = false }) => {
    const getBadgeBlock = (tags) => {
        if (!tags) return null;
        let slug = null;
        tags.some((tag, index) => {
            if (
                tag.slug !== "inspo" &&
                tag.slug !== "brand-stories" &&
                tag.slug !== "eco-alliance" &&
                tag.slug !== "noissuetv" &&
                tag.slug !== "noissue-101" &&
                tag.slug !== "biz-advice"
            ) {
                slug = getBadge(tag);
                if(slug) return true;
            }
            return false;
        });
        if (slug) {
            return (
                <div key={"badge" + id}>
                    <style jsx>
                        {`
                            .badge {
                                width: 8rem;
                                height: 8rem;
                                display: block;
                                border-radius: 100%;
                                background: url(${slug}) no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: -4rem;
                                right: 1rem;
                            }
                        `}
                    </style>
                    <div className="badge" />
                </div>
            );
        }
        return "";
    };

    return (
        <>
            <style jsx>
                {`
                        .indus {
                            color: #fc566f;
                        }

                        .item {
                            ${ !isSearchCard ? 'margin-right: 2.5rem;' : ''}
                            ${ isSearchCard ? 'max-width: 36rem; margin: auto;':''}
                        }
                        @media (min-width: 699px) and (max-width: 1439px){
                            .item {
                                ${ isSearchCard ? 'padding: 0 1.2rem;':''}
                            }
                        }
                        .item :first-of-type {
                            ${ !isSearchCard ? 'margin-left: 10rem;' : 'margin-top: 6rem;'}                            
                        }
                        @media (max-width: 400px) {
                            .item :first-of-type {
                                ${ !isSearchCard ? 'margin-left: 1rem;' : 'margin-top: 6rem;'}                            
                            }    
                        }
                        .rose {
                            display: block;
                            color: #fc566f;
                            margin: 1rem 0;
                            font-weight: 400;
                        }

                        .date {
                            font-size: 1.3rem;
                            color: #c8c8c8;
                            display: block;
                        }

                        .tags {
                            width: 100%;
                            margin: 1.4rem 0;
                        }
                        .tag-link {
                            border-radius: 2rem;
                            border: unset;
                            margin: 0.5rem;
                            color: #979797;
                            background: #ededed;
                            font-size: 1rem;
                            line-height: 2.4em;
                            height: 2.4rem;
                            padding: 0 0.9rem;
                            font-family: Soleil, -apple-system,
                                BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
                                Ubuntu, Cantarell, Fira Sans, Droid Sans,
                                Helvetica Neue, sans-serif;
                            letter-spacing: 0;
                            text-align: center;
                            display: inline-block;
                        }

                        .wrapper {
                            text-align: start;
                            background: #ffffff;
                            box-shadow: ${isSearchCard? '1rem 1rem 0rem 0rem rgb(0 0 0 / 11%)':'7px 7px 0px 0px rgb(0 0 0 / 11%)'};
                            border-radius: 1rem;
                            ${ isSearchCard ? 'max-width: 36rem;':'width: 33rem;'}
                            position: relative;
                            height: 58rem;
                        }
                        .f-img {
                            display: block;
                            width: 100%;
                            border-top-right-radius: 1rem;
                            border-top-left-radius: 1rem;
                            height: 28rem;
                        }
                        .header {
                            justify-content: space-between;
                            display: flex;
                            flex-wrap: wrap;
                            width: 100%;
                            overflow: hidden;
                            padding: 2rem;
                            height: 30rem;
                        }

                        .title {
                            font-family: Soleil;
                            font-size: 1.8rem;
                            line-height: normal;
                            color: #393972;
                            line-height: 2rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            word-break: break-word;
                            max-height: 6rem;
                        }
                        .desc {
                            font-size: 1.4rem;
                            color: #616161;
                            line-height: normal;
                            font-weight: 300;
                        }
                        .author {
                            margin-top: 1.9rem;
                            margin-right: 1rem;
                            position: relative;

                        }
                        .a-img {
                            width: 6.1rem;
                            height: 6.1rem;
                            display: block;
                            border-radius: 100%;
                            border: 0.1rem solid #eee;
                        }
                        .a-name {
                            font-size: 1.5rem;
                            font-weight: bold;
                            color: #393972;
                            letter-spacing: 0;
                            margin-top: 3.5rem;
                            display: block;

                        }
                        .col {
                            flex: 1;
                        }
                `}
            </style>
            <div className="wrap-card" key={"wc1" + id}>
                <div className="item" key={"c" + id}>
                    <div className="wrapper">
                        {getBadgeBlock(post.tags)}
                        <a href={`/blog/${post.slug}`}>
                            <div
                                className="f-img"
                                style={{
                                    background: `url(${post.feature_image}) no-repeat center center / cover`,
                                }}
                            />
                        </a>
                        <div className="header">
                            <h2 className="title">{post.title}</h2>
                            <p className="desc">
                                {post.excerpt && post.excerpt.slice(0, 100)}
                                <span>...</span>
                                <a href={`/blog/${post.slug}`} className="rose">
                                    Read More
                                </a>
                            </p>
                            <a
                                className="author"
                                href={`/blog/author/${post.primary_author?.slug}`}
                            >
                                <div
                                    className="a-img"
                                    style={{
                                        background: `url(${post.primary_author?.profile_image}) no-repeat center center / cover`,
                                    }}
                                />
                            </a>

                            <div className="col">
                                <a
                                    className="a-name"
                                    href={`/blog/author/${post.primary_author?.slug}`}
                                >
                                    by {post.primary_author?.name}
                                </a>
                                <span className="date">
                                    {post.display_created_at}
                                </span>
                            </div>
                            <div className="tags">
                                {post.tags &&
                                    post.tags
                                        .map((tag, index) => {
                                            if (
                                                tag.slug !== "inspo" &&
                                                tag.slug !== "brand-stories" &&
                                                tag.slug !== "eco-alliance" &&
                                                tag.slug !== "noissue-101" &&
                                                tag.slug !== "biz-advice"
                                            ) {
                                                return (
                                                    <a className="tag-link"
                                                        href={`/blog/tag/${tag.slug}`}
                                                        key={index}
                                                    >
                                                        {tag.name}
                                                    </a>
                                                );
                                            }
                                            return null;
                                        })
                                        .splice(0, 2)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WrapCardCommon;
